import { DocumentViewerModal } from "../../../features/beneficiary-document-reports/ui/DocumentViewerModal";
import { AddAlertModal } from "./AddAlertModal";
import { HomologationSearchModal } from "./HomologationSearchModal";
import { MissingRequirementsModal } from "./MissingRequirementsModal";
import { ServicesResponseModal } from "./ServicesResponseModal";

// Agrupa todos los modales de la gestión estándar para mantener el widget
// principal centrado en su layout.
export const StandardManagementModals = ({
  pdf,
  missing,
  onCloseMissing,
  servicesResult,
  onCloseServicesResult,
  addModal,
  homologation,
  defaultJourney,
}) => (
  <>
    <DocumentViewerModal
      isOpen={pdf.viewer.isOpen}
      title="Visor de documento"
      subtitle={pdf.viewer.title}
      documentUrl={pdf.viewer.url}
      onClose={pdf.close}
      onDownload={pdf.downloadCurrent}
    />

    <MissingRequirementsModal
      isOpen={missing.isOpen}
      message={missing.message}
      onClose={onCloseMissing}
    />

    <ServicesResponseModal
      isOpen={servicesResult.isOpen}
      result={servicesResult.result}
      onClose={onCloseServicesResult}
    />

    <AddAlertModal
      isOpen={addModal.isOpen}
      onClose={addModal.onClose}
      columns={addModal.columns}
      dataSource={addModal.dataSource}
      loading={addModal.loading}
    />

    <HomologationSearchModal
      isOpen={homologation.modal.isOpen}
      onClose={homologation.closeModal}
      onSelect={homologation.select}
      defaultJourney={defaultJourney}
    />
  </>
);